import type { InjectionKey } from "vue";

export const vcTableKey: InjectionKey<VcTableContextType> = Symbol("vc-table-context");
